$(document).ready(function() {
  function ajaxFormSubmit() {
    var $form = $(".formbuilder2");
    $form.on("submit", function() {
      $.ajax({
        method: "POST",
        url: "/actions/formBuilder2/entry/submitEntry",
        data: $form.serialize(),
        cache: false,
        dataType: "json"
      }).done(function(msg) {
        var $formWrapper = $(".formbuilder2");
        $formWrapper.html("thanks");
      });
      return false;
    });
  }
  ajaxFormSubmit();
});  


// WEBPACK FOOTER //
// ./source/assets/js/modules/formbuilder2.js